const ALIPAY_CLIENT_APP_IDS = [
  '25041015072537435450802063', // 测试
  '25042913485195984330802002' // 生产
]

export default {
  methods: {
    reportPatientReply (messageType) {
      const orderDetail = this.orderDetail || {}
      const userInfo = this.userInfo || {}
      const urlParams = this.urlParams || {}
      const clientAppID = orderDetail.clientAppID || userInfo.clientAppID || urlParams.clientAppID

      // 仅支付宝指定应用需要通知 RIC，其他渠道保持原有 IM 发送流程。
      if (!ALIPAY_CLIENT_APP_IDS.includes(clientAppID)) {
        return Promise.resolve()
      }

      const orderID = orderDetail.inquiryOrderID || orderDetail.orderID
      if (!orderID) {
        console.warn('[sendPatientReply] orderID is missing')
        return Promise.resolve()
      }

      return this.$_http
        .post(this.$_API.H5_INQUIRY_SEND_PATIENT_REPLY, {
          orderID,
          messageType
        })
        .catch(error => {
          // IM 消息已发送成功，通知失败不改变消息的发送状态。
          console.warn('[sendPatientReply] report failed:', error)
        })
    }
  }
}
